import { css, html, render } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { FilterSectionConfig } from "../../types";
import { ModuleDefinition } from "@reporting/rp-types/definition";
import { ContextData } from "@reporting/rp-types/analytics";
import { Container } from "@reporting/rp-app-host";
import { Layout, OmegaComponent, Panel, dom } from "@omegagrid/core";
import { BaseSection } from "./sectionBase";

export type FilterSectionState = {
	collapsed: boolean;
}

@customElement('rp-fsection')
export class FilterSection extends OmegaComponent<FilterSectionState> implements Layout {

	static styles = [OmegaComponent.styles, css`
		og-panel {
			border-left: none;
			border-right: none;
			border-top: none
		}

		og-panel[collapsed] {
			border-bottom: none;
		}

		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 5px;
		}

		.header-text {
			text-transform: uppercase;
		}
	`];

	@property({type: Object})
	config: FilterSectionConfig;

	@property({type: Object})
	container: Container;

	@property({type: Object})
	module: ModuleDefinition;

	@property({type: Object})
	contextData: ContextData;

	@query('og-panel')
	panel: Panel;

	@query('.body')
	panelBody: HTMLDivElement;

	private _sectionComponent: BaseSection;
	get sectionComponent() { return this._sectionComponent }

	async updated(props: Map<string, unknown>) {
		// section factories bake module-dependent data into the component
		// (custom visualizations, indicator dimensions, ...), so the component
		// must be recreated when the module changes
		const moduleChanged = this._sectionComponent && props.has('module')
			&& this.module && props.get('module') !== this.module;

		if ((props.has('config') || moduleChanged) && this.config?.factory) {
			this._sectionComponent = await this.config.factory({
				module: this.module,
				container: this.container,
				config: this.config,
			});

			this._sectionComponent.config = this.config;
			this._sectionComponent.context = this.contextData;
			this._sectionComponent.module = this.module;
			dom.empty(this.panelBody);
			this.panelBody.appendChild(this._sectionComponent);
			return;
		}

		if (!this._sectionComponent) return;

		if (props.has('contextData')) {
			this._sectionComponent.context = this.contextData;
		}

		if (props.has('module') && this.module) {
			this._sectionComponent.module = this.module;
		}
	}

	render = () => html`
		<og-panel
			collapsible
			?collapsed="${this.state?.collapsed}"
			@resizestop="${() => this.updateState({collapsed: this.panel.collapsed})}">

			<div class="header" slot="header">
				<og-icon .icon="${this.config?.icon}" fixed-width></og-icon> <span class="header-text">${this.config?.title}</span>
			</div>

			<div class="body" slot="body" style="height: 100%; overflow: hidden"></div>
		</og-panel>
	`

	layout() {}

}
